import { connect } from "react-redux";
import PreSalesListing from "./preSalesListing";
import { bindActionCreators } from "redux";
import {
  getPreSaleListing,
  getStatusList,
  getDealStatusList,
  UpdateLeadStatus,
  getListFilterData,
  fetchZones,
} from "services/redux/sales/preSaleListing/action";

import {
  getAssignee,postBulkAssignment
} from "services/redux/sales/changeAssignee/action";

const mapStateToProps = (state) => ({
  perSalesList: state.preSalesListReducer.perSalesList,
  statusList: state.preSalesListReducer.statusList,
  dealStatusList: state.preSalesListReducer.dealStatusList,
  filterDropdownList: state.preSalesListReducer.filterDropdownList,
  getFetchZones: state.preSalesListReducer.getFetchZones,
  assign: state.assigneeReducer.assign,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getPreSaleListing,
      getStatusList,
      getDealStatusList,
      UpdateLeadStatus,
      getListFilterData,
      fetchZones,
      getAssignee,
      postBulkAssignment
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(PreSalesListing);
